import React from "react";

function TextareaField({input, className, placeholder, meta: {touched, error, dirtySinceLastSubmit, submitError}}) {
    className = (touched && error) || (!dirtySinceLastSubmit && submitError) ? className+' control-error' : className;

    return <textarea
        {...input}
        className={className}
        placeholder={placeholder}
    />
}

export default TextareaField